export default __webpack_public_path__ + "static/media/Workday.0b07ca09.svg";